import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../utils/safeHTML';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { useModal } from '../../../hooks/useModal';
import Icon from '../../baseComponents/gui/icon/Icon';
import classNames from 'classnames';
import { useTranslation } from '../../../translations';
import { copyrightParams } from '../../../constants/copyright';

const InactiveGameModal = React.forwardRef(function InactiveGameModal(
  { icon, title, description, buttons, mod, copyright },
  ref,
) {
  const { closeModal } = useModal();
  const { t } = useTranslation();

  return (
    <CustomModal>
      <div
        className={classNames(`inactive-game-modal`, {
          [`inactive-game-modal_${mod}`]: mod,
        })}
        ref={ref}
      >
        <div className='inactive-game-modal__bg' />
        <div className='inactive-game-modal__content'>
          {icon && (
            <div className='inactive-game-modal__icon'>
              <Icon name={icon} />
            </div>
          )}
          {title && <h2 className='inactive-game-modal__title'>{safeHTML(t(title))}</h2>}
          {description && <p className='inactive-game-modal__text'>{safeHTML(t(description))}</p>}
        </div>
        {copyright && <div className='inactive-game-modal__copyright'>{safeHTML(t(copyright, copyrightParams))}</div>}
      </div>
      <div className={'inactive-game-modal__buttons'}>
        {buttons &&
          buttons.map((item, id) => (
            <CustomButton
              key={`CustomButton-${id}`}
              {...item}
              onClick={() => {
                closeModal({ type: 'all' });
              }}
            />
          ))}
      </div>
    </CustomModal>
  );
});
export default InactiveGameModal;
InactiveGameModal.propTypes = {};
